import ObjectMapController from "./object_map_controller"

export default class ExchangeMarketDealsMapController extends ObjectMapController {
  static values = {
    ...ObjectMapController.values,
    subjectType: "deal",
    parentSubjectType: "market",
  }
}
